import React, { useEffect } from "react";
import { PageSpinner } from "components/PageSpinner/PageSpinner";
import { User } from "lib/auth";
import { useAuth } from "lib/hooks/useAuth";
import { useRouter } from "lib/hooks/useRouter";

export const withUser = <
  Props,
  Redirect extends boolean | undefined = undefined,
  WithUserProps = Props & Redirect extends true | undefined
    ? { user: User }
    : { user?: User },
>(
  Component: (props: WithUserProps) => React.ReactElement | null,
  initialRedirect?: Redirect,
): ((props: Props) => React.ReactElement | null) => {
  return (props) => {
    const redirect = initialRedirect ?? true;
    const { user } = useAuth();
    const { navigate } = useRouter();

    useEffect(() => {
      if (redirect && !user) navigate({ routeName: "Login" });
    }, [user]);

    if (redirect && !user) return <PageSpinner />;

    return <Component {...(props as any)} user={user} />;
  };
};
